import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IReservation } from '@internal-models/reservation.model';
import { ICommunication } from '@shared-libs/interfaces';

@Injectable({
	providedIn: 'root',
})
export class ReservationProvider extends Provider<IReservation> {
	protected readonly url: string = '/reservations';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getOne(reservationId: string): Promise<IReservation> {
		return this.process(this.api.get(`${this.url}/${reservationId}`)) as Promise<IReservation>;
	}

	public getAllOfEventDay(
		reservationId: string,
		eventId: string,
		calendarEventId: string
	): Promise<Array<IReservation>> {
		return this.process(this.api.get(`${this.url}/${reservationId}/${eventId}/${calendarEventId}`)) as Promise<
			Array<IReservation>
		>;
	}

	public getAllOfClient(clientId: string): Promise<Array<IReservation>> {
		return this.process(this.api.get(`${this.url}/client/${clientId}`)) as Promise<Array<IReservation>>;
	}

	public createRegistration(reservation: IReservation): Promise<IReservation> {
		return this.process(this.api.post(`${this.url}/registration`, reservation)) as Promise<IReservation>;
	}

	public registerWalkIn(reservation: Omit<IReservation, 'Communication'>): Promise<IReservation> {
		return this.process(this.api.post(`${this.url}/walk-in`, reservation)) as Promise<IReservation>;
	}

	public registerForLesson(reservation: IReservation): Promise<IReservation> {
		return this.process(this.api.post(`${this.url}/lesson`, reservation)) as Promise<IReservation>;
	}

	public reserve(reservationId: string, reservation: IReservation): Promise<IReservation> {
		return this.process(this.api.put(`${this.url}/${reservationId}/reserve`, reservation)) as Promise<IReservation>;
	}

	public update(reservationId: string, reservation: IReservation): Promise<IReservation> {
		return this.process(this.api.put(`${this.url}/${reservationId}`, reservation)) as Promise<IReservation>;
	}

	public delete(
		reservationId: string,
		cancellation: { CancellationReasonId: string; cancellationInfo: string },
		Communication: ICommunication
	): Promise<void> {
		return this.process(this.api.delete(`${this.url}/${reservationId}`, { ...cancellation, Communication }));
	}
}
